import Loadable from "react-loadable"
import FullScreenLoading from "@/components/FullScreenLoading"

export default (loader) =>
  Loadable({
    loader,
    loading: FullScreenLoading
  })
